import React from 'react'
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { AccessibilityBypassBlock } from '@skillz/accessibility';
import Header from './header/Header';
import ScrollLTR from '../ui/scrollLTR/ScrollLTR';
import MainMenu from './mainMenu/MainMenu';
import LandscapeMessage from './layoutMobile/landscapeMessage/LandscapeMessage';
import Support from '../shared/support/Support';
import classes from './Layout.module.css';

const Layout = () => {
    const { lang, texts } = useSelector(state => state.translate);

    return (
        <div className={`${classes.Layout} ${classes[`MyLang_${lang}`]}`}>

            <AccessibilityBypassBlock id="main" text={texts.skipToMainContent} />

            <MainMenu />

            <div className={classes.LeftSide}>
                <Header />
                <ScrollLTR height={`calc(100% - 89px)`}>
                    <div id="main" className={classes.MainWrapper}>
                        <Outlet></Outlet>
                    </div>
                </ScrollLTR>
            </div>

            <Support />
            <LandscapeMessage />
        </div>
    )
}

export default Layout;